export const notifications = {
  SUCCESS: 'Registro guardado correctamente!',
  DELETE_SUCCESS: 'Registro eliminado correctamente!',
  ERROR: 'Error',
  NAME: 'Ese nombre ya fue registrado.',
  NOT_FOUND_USER: 'Usuario no encontrado!',
  PDF_SUCCESS: 'PDF generado correctamente',
  PDF_ERROR: 'Hubo un problema al generar el PDF',
};
